/* eslint-disable default-param-last */
import * as actionType from '../constants/services';
import * as authType from '../constants/auth';

const initialState = {
  services: [],
  resellingServices: [],
};

export default function materialsReducer(state = initialState, action) {
  switch (action.type) {
    case authType.CLEAR_APP_DATA:
    case authType.USER_LOGOUT:
      return {
        ...initialState,
      };
    case actionType.USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionType.GET_SERVICES:
      return {
        ...state,
        services: action.payload,
      };
    case actionType.GET_RESELLING_SERVICES:
      return {
        ...state,
        resellingServices: action.payload,
      };
    default:
      return state;
  }
}

